import Swiper from 'swiper/bundle';
import $ from 'jquery'

const swiper = new Swiper('.front-swiper-container', {
  slidesPerView: 3,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 0
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 2,
      spaceBetween: 0
    },
    // when window width is >= 640px
    996: {
      slidesPerView: 2,
      spaceBetween: 50
    },

    // when window width is >= 640px
    1200: {
      slidesPerView: 3,
      spaceBetween: 100
    }
  }
});

const swiper2 = new Swiper('.img-swiper-container', {
  slidesPerView: 'auto',
  loop: true,
  centeredSlides: true,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const openButton = document.getElementById("menu-btn-open");
const closeButton = document.getElementById("menu-btn-close");
const menu = document.getElementById("menu-inner");

openButton.addEventListener("click", () => {
  menu.classList.remove("right");
  menu.classList.add("left");
  menu.classList.add("menu-inner--open");
  menu.style.minHeight = "100vh";
  closeButton.classList.add("active");
});
closeButton.addEventListener("click", () => {
  menu.classList.remove("left");
  menu.classList.add("right");
  menu.classList.remove("menu-inner--open");
  menu.style.minHeight = "0%";
  closeButton.classList.remove("active");
});

if ($('body section.contact').length) {
  const contactSubmit = document.querySelector("input.wpcf7-submit");
  let wrapper = document.createElement("a");
  wrapper.setAttribute("class", " primary-btn primary-btn--tri");
  contactSubmit.parentNode.insertBefore(wrapper, contactSubmit);
  wrapper.appendChild(contactSubmit);
  console.log(contactSubmit);
}

if ($('body.home').length) {
  const block1 = document.getElementById("collapse-first");
  const block2 = document.getElementById("collapse-second");
  const block3 = document.getElementById("collapse-third");
  const block4 = document.getElementById("collapse-fourth");

  const btn1 = document.getElementById("btn-first");
  const btn2 = document.getElementById("btn-second");
  const btn3 = document.getElementById("btn-third");
  const btn4 = document.getElementById("btn-fourth");

  btn1.addEventListener("click", () => {
    block1.classList.add("active");
    block2.classList.remove("active");
    block3.classList.remove("active");
    block4.classList.remove("active");
    btn1.classList.add("active");
    btn2.classList.remove("active");
    btn3.classList.remove("active");
    btn4.classList.remove("active");
  });
  btn2.addEventListener("click", () => {
    block2.classList.add("active");
    block1.classList.remove("active");
    block3.classList.remove("active");
    block4.classList.remove("active");
    btn2.classList.add("active");
    btn1.classList.remove("active");
    btn3.classList.remove("active");
    btn4.classList.remove("active");
  });
  btn3.addEventListener("click", () => {
    block3.classList.add("active");
    block1.classList.remove("active");
    block2.classList.remove("active");
    block4.classList.remove("active");
    btn3.classList.add("active");
    btn2.classList.remove("active");
    btn1.classList.remove("active");
    btn4.classList.remove("active");
  });
  btn4.addEventListener("click", () => {
    block4.classList.add("active");
    block2.classList.remove("active");
    block3.classList.remove("active");
    block1.classList.remove("active");
    btn4.classList.add("active");
    btn2.classList.remove("active");
    btn3.classList.remove("active");
    btn1.classList.remove("active");
  });
}

$(window).on('load', function() {
  $('#homeModal').modal('show');
});

$('#changeFontSize').on('click', function (e) {
  $('body').toggleClass("bigger-font"); //you can list several class names
  e.preventDefault();
});





// WEBPACK FOOTER //
// ./resources/assets/js/webcommitment.js